export default __webpack_public_path__ + "static/media/neap_logo.a7ad2993.svg";